import api from "../../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  create(data) {
    return api.post(`/api/v1/item-price`, data);
  },
  update(data) {
    return api.put(`/api/v1/item-price/${data.id}`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/item-price/${id}`);
  },
};
